<!--  -->
<template>
  <div>
<!--    <div class="haedTab bgImg"></div>-->
    <div class="sub_wrapper">
<!--      <div class="haedTab">
        <el-radio-group v-model="radio1" @change="chooseChange">
          <el-radio-button label="1">免申即享政策</el-radio-button>
          <el-radio-button label="2">我兑换的政策</el-radio-button>
        </el-radio-group>
      </div>-->
      <div class="banner_wrap">
      <div class="b_cont">
        <div class="b_ss_wrap">
          <input
            type="text"
            placeholder="请输入关键字查询"
            v-model="searchInfo.keyWord"
            class="ipt_txt"
          />
            <button @click="gettabelList" class="ss_btn">查询</button>
        </div>
      </div>
      </div>
        <div class="main_wrap w_1200">
          <FilterGroup  @change="changeSearch">
            <FilterItem
              v-model="searchInfo.zcfs"
              label="扶持类型:"
              :list="getDictList('sq_policy_zjlx')"
              valueKey="key"
              fold
            ></FilterItem>
            <FilterItem
              ref="FilterCheckBoxMine3"
              v-model="searchInfo.areacode"
              label="行政区划"
              :list="areaList"
              valueKey="value"
              labelKey="label"
              fold
            ></FilterItem>
            <FilterItem
              v-model="searchInfo.deptId"
              label="主管部门:"
              :list="hydlList"
              labelKey="deptName"
              valueKey="deptCode"
              fold
            ></FilterItem>
          </FilterGroup>
          <el-row class="searchChoosePart" >
            <el-col :span="2.5" class="searchLeft">政策实施时间:</el-col>
            <el-col :span="21" class="searchRight">
              <el-date-picker
                v-model="searchInfo.startTime"
                type="date"
                placeholder="选择日期"
                @change="changeSearch"
              >
              </el-date-picker>
            </el-col>
          </el-row>

<!--        <div class="searchAbsolute">
          <el-button class="searchBtn2" @click="showDetail"
            >免申自查<br />条件自查</el-button
          >
        </div>-->

    <div style="margin-top: 2.5rem">
      <div class="def-container flex-row tabCon" v-show="radio1 == '1'">
        <div
          class="tabItem"
          :class="{ clicked: tabActive == 'policy' }"
          @click="changeTab('policy')"
        >
          免申即享政策
        </div>
        <div
          class="tabItem"
          :class="{ clicked: tabActive == 'policy1' }"
          @click="changeTab('policy1')"
        >
          我已兑现的政策
        </div>
        <div
          class="tabItem"
          :class="{ clicked: tabActive == 'policy2' }"
          @click="changeTab('policy2')"
        >
          我可兑现的政策
        </div>
<!--        <div
          class="tabItem"
          :class="{ clicked: tabActive == 'project' }"
          @click="changeTab('project')"
        >
          免申即享政策项目
        </div>-->
      </div>
      <el-tabs  v-model="tabIndex" @tab-click="handleSelect">
        <el-tab-pane  label="全部" name="''"></el-tab-pane>
      <!--  <el-tab-pane  label="国家级" name="0"></el-tab-pane>
        <el-tab-pane  label="省级" name="1"></el-tab-pane>
        <el-tab-pane  label="市级" name="2"></el-tab-pane>-->
      </el-tabs>
      <div style="margin-bottom: 2.5rem" class="result_list result_list1">
        <el-table style="cursor: pointer;" :data="policyDataList" :show-header="false">
          <el-table-column>
            <el-row class="re-top" slot-scope="item">

              <el-col :span="20">
                <div @click="topage(item)" class="re-list-name" v-if="tabActive == 'policy' || tabActive == 'policy1' || tabActive == 'policy2'">
                  {{ item.row.policyName }}
                </div>
                <div @click="topage(item)" class="re-list-name" v-if="tabActive == 'project'">
                  {{ item.row.itemName }}
                </div>
                <div class="re-list-info" v-if="tabActive == 'project'">
                  <span style="color: blue">(政策)</span
                  >{{ item.row.policyName }}
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <!-- <span class="re-tag">认定奖励</span> -->
                  <span class="re-tag" :title="item.row.deptName">{{
                    item.row.deptName
                  }}</span>
                </div>
              </el-col>
              <el-col :span="6" style="margin-top: 0.7rem" align="left">

                有效时间:{{ item.row.startTime }}至{{
                  cpu_limitTime(item.row.endTime)
                }}
              </el-col>
              <el-col :span="4" style="margin-top: 0.7rem">
                发布时间:{{ item.row.publictime }}
              </el-col>
              <el-col :span="4" style="margin-top: -0.8rem;margin-left:10rem;" align="right">
                <!-- <el-button class="rt-btn" v-if="radio1 == '2'" @click="topage(item)"
                  >已开始</el-button
                >
                <el-button
                  class="rt-btn"
                  v-if="radio1 == '1' && item.row.isCheck == 0"
                  @click="topage(item)"
                  >不可申报</el-button
                > -->
                <el-button
                  class="rt-btn"
                  v-if="radio1 == '1'"
                  @click="topage2(item)"
                  >{{ buttonText }}</el-button
                >
              </el-col>
            </el-row>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pg-css"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagenum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagesize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="searchInfo.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="detailVisible" width="53vw">
      <template v-slot:title>
        <div class="dt-top">免申自查条件自查</div>
      </template>
      <div v-show="dialogShow == 1">
        <el-form ref="form" label-position="top">
          <el-row v-for="(item, index) in questionList" :key="index">
            <el-form-item :label="index + 1 + '、' + item.questionName">
              <el-input
                placeholder="请输入问题答案"
                v-model="item.questionAnswer"
                v-show="item.questionType == '2'"
              />
              <el-radio-group
                v-model="item.questionAnswer"
                v-show="item.questionType == '0'"
              >
                <el-radio
                  :label="items.optionValue"
                  v-for="(items, indexs) in item.questionOptionList"
                  :key="indexs"
                  >{{ items.optionName }}</el-radio
                >
              </el-radio-group>
              <el-checkbox-group
                v-model="item.questionAnswer"
                v-show="item.questionType == '1'"
              >
                <el-checkbox
                  v-for="(items, indexs) in item.questionOptionList"
                  :label="items.optionValue"
                  :key="indexs"
                  >{{ items.optionName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-row>
        </el-form>
        <el-divider></el-divider>
        <div class="dt-div-btn">
          <el-button class="dt-skip" @click="detailVisible = false"
            >返回</el-button
          >
          <el-button class="dt-confirm" @click="submitForm">确认</el-button>
        </div>
      </div>
      <div v-show="dialogShow == 2">
        <div class="resultPart">
          <div class="successPart">
            <img
              src="~@/assets/images/successIcon.png"
              alt=""
              style="width: 100%"
            />
          </div>
          <p v-if="policyCanmsg">
            "根据您的条件，目前<span style="color: red">可以享受</span
            >政策免申即享服务！您可以登录系统进行授权，查看免申即享政策。"
          </p>
          <p v-else>
            "根据您的条件，目前<span style="color: red">无法享受</span
            >政策免申即享服务！您可以登录系统进行授权，完善信息后再次查询。"
          </p>
        </div>
        <div class="dt-div-btn" style="margin-top: 5rem">
          <el-button class="dt-skip" @click="dialogShow = 1">返回</el-button>
          <el-button
            class="dt-confirm"
            @click="
              detailVisible = false;
              dialogShow = 1;
            "
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="政策兑现"
      :visible.sync="dialogVisible"
      width="800"
      :before-close="handleClose">
      <span slot="footer" class="dialog-footer">

        <el-form label-position="right" label-width="140px" :model="formData" style="width:90%;">

          <el-form-item label="政策名称">
            <el-input v-model="formData.policyName" readonly></el-input>
          </el-form-item>
          <el-form-item label="实施期限">
            <el-input v-model="formData.endTime" readonly></el-input>
          </el-form-item>
           <!-- <el-form-item label="企业id">
            <el-input v-model="formData.id" readonly></el-input>
          </el-form-item> -->
          <el-form-item label="企业名称">
            <el-input v-model="formData.enterpriseName" readonly></el-input>
          </el-form-item>
          <el-form-item label="法人姓名">
            <el-input v-model="formData.enterpriseFr" readonly></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="formData.phone" readonly></el-input>
          </el-form-item>
          <el-form-item label="收款账号">
            <el-input v-model="formData.skNum"></el-input>
          </el-form-item>
          <el-form-item label="收款行">
            <el-input v-model="formData.skBank"></el-input>
          </el-form-item>
          <el-form-item label="申请材料">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-change="onChange"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList">
              <el-button size="small" class="edit"  >点击上传</el-button>
<!--              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
            </el-upload>
          </el-form-item>
        </el-form>

        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button  class="edit" @click="dialogVisibleSubmit(formData)">确定兑现</el-button>
      </span>
    </el-dialog>
  </div>
  </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "@/assets/newStyle/css/idx.scss";
</style>
<script>
import {
  FilterGroup,
  FilterItem,
} from "@/views/policyLibrary/components/filter/index.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      uploadUrl: this.$httpApi.baseUrl + "/dev-api/fileManageApi/common/upload",
      fileList: [],
      dialogVisible: false,
      buttonText: '查看详情',
      tabActive: "policy",
      tabIndex: "''",
      radio1: "1",
      searchInfo: {
        keyWord: "",
        zcfs: "",
        policyLevel: "",
        startTime: "",
        deptId: "",
        pageSize: 10000,
        pageNum: 1,
        total: 0,
        areaList: [], //地区列表
        areacode: "", // 行政区划
      }, //搜索内容
      policyDataList: [], //政策list
      detailVisible: false,
      formData: {
        skNum: '',
        skBank: '',
      },
      dialogShow: 1, //弹框内显示
      hydlList: [], //主管部门List
      searchDataAreaId: "", //搜索部门
      questionList: [],
      checkboxAnswer: [],
      areaList: [], //地区列表
      radioAnswer: "",
      policyCanmsg: false,
      showpolicyList: [],
      pagesize: 10,
      pagenum: 1,
      requesturl: "/dev-api/avoid/apply/selectAvoidApplyList",
      requesturlType: -1,  //  访问接口要求 新增1我兑现的政策  0我可兑现的政策
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    cpu_limitTime() {
      return function (endTime) {
        if (endTime == undefined || endTime == "undefined" || endTime == "") {
          return "长期有效";
        } else if (endTime == "长期有效" || endTime.slice(0, 4) == "2099") {
          return "长期有效";
        }
        return endTime;
      };
    },
  },
  components: { FilterGroup, FilterItem },
  created() {
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "sq_policy_zjlx", // 扶持方式(支持方式)
      ],
    });
  //  this.gettabelList();
    this.getquestionList();

    this.getAreaList();
  },
  mounted() {
    // this.queryLabelDept();
    this.getDeptList();
    // this.gettabelList();
    let requesturlType = window.sessionStorage.getItem("requesturlType");
    if(requesturlType){
      if(requesturlType == 1){
        this.changeTab('policy1');
      }else if(requesturlType == 0){
        this.changeTab('policy2');
      }else{
        this.changeTab('policy');
      }
    }else{
      this.changeTab('policy');
    }
  },
  beforeRouteEnter(to, from, next){
    if(from && from.name != 'showPolicyDetail'){
      window.sessionStorage.setItem("requesturlType", '');  //  置为空
    }
    next();
  },
  /*watch: {
    $route: {
      handler(val, oldVal){
        console.dir(arguments);
        console.log(val, oldVal);

        if(oldVal && oldVal.name != '/showPolicyDetail'){
          window.sessionStorage.setItem("requesturlType", '');  //  置为空
        }
      },
      immediate: true,
    },
  },*/
  methods: {
    dialogVisibleSubmit(data){
      if(!(this.formData.skNum.trim() && this.formData.skBank.trim())){
        this.$message.error('表单值未填写完整！');
      }else{
        let url = "/dev-api/avoidprocess";
        let status = "0";
        data['status'] = "0";
      //  window.sessionStorage.getItem()
      //
        this.$httpApi
        .post(url, data)
        .then((r) => {
          if (r.code == 200) {
            this.$message.success("添加成功")
            return
          //  this.dialogVisible = true;
          } else {
            this.$message.error("添加失败")
            return
         //   this.dialogVisible = false;
          }
        })
        .catch((e) => {});
        this.dialogVisible = false;
      }
    },
    onChange(file, fileList){
      console.log(file, fileList);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleClose(done) {
      done();
      /*this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});*/
    },
    changeSearch(label, value) {
      this.searchInfo.tyshxydm = '';
      this.searchInfo.authorStatus = '';
      if(this.requesturlType != -1){ //  需要登录才能查看
        if (this.userInfo) {
          this.searchInfo.tyshxydm = this.userInfo.tyshxydm;
          this.searchInfo.authorStatus = this.requesturlType;
        } else {
          this.$router.push({ path: "/login2" });
        }
      }
      switch (label) {
        case "行政区划":
          this.searchDataAreaId = value;
          this.searchInfo.deptcode = "";
          this.hydlList = [];
          // this.$refs.FilterCheckBoxMine3.cleanItem();
          this.getDeptList();
          break;
        default:
          break;
      }
      this.showpolicyList = [];
      this.policyDataList = [];
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "loadingin",
      });
      this.$httpApi
        .post(this.requesturl, this.searchInfo)
        .then((r) => {
          let arr = r.data.list;
          arr.sort(this.compare("isCheck"));
          // 排序,可申报项目在前，isCheck为0不可申报
          this.showpolicyList = arr;
          this.policyDataList = this.showpolicyList.slice(0, 10);
          this.searchInfo.total = r.data.total;
          loading.close();
          this.pagesize = 10;
          this.pagenum = 1;
        })
        .catch((e) => {});
    },
    showDetail() {
      this.detailVisible = !this.detailVisible;
    },
    submitForm() {
      let url = "/dev-api/avoid/apply/questionToPolicy";
      let policyIdList = [];
      this.showpolicyList.forEach((item) => {
        policyIdList.push(item.policyId);
      });
      let submitquestionList = JSON.parse(JSON.stringify(this.questionList));
      submitquestionList.forEach((item) => {
        if (Array.isArray(item.questionAnswer)) {
          item.questionAnswer = item.questionAnswer.join(",");
        }
      });
      let params = {
        policyIdList: policyIdList,
        questionList: submitquestionList,
      };
      this.$httpApi
        .post(url, params)
        .then((r) => {
          if (r.code == 200) {
            this.policyCanmsg = true;
          } else {
            this.policyCanmsg = false;
          }
          this.dialogShow = 2;
        })
        .catch((e) => {});
    },
    // 获取所有政策
    gettabelList() {
      this.searchInfo.tyshxydm = '';
      this.searchInfo.authorStatus = '';
      if(this.requesturlType != -1){ //  需要登录才能查看
        if (this.userInfo) {
          this.searchInfo.tyshxydm = this.userInfo.tyshxydm;
          this.searchInfo.authorStatus = this.requesturlType;
        } else {
          this.$router.push({ path: "/login2" });
        }
      }
      this.showpolicyList = [];
      this.policyDataList = [];
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "loadingin",
      });
      this.$httpApi
        .post(this.requesturl, this.searchInfo)
        .then((r) => {
          let arr = r.data.list;
          arr.sort(this.compare("isCheck"));
          // 排序,可申报项目在前，isCheck为0不可申报
          this.showpolicyList = arr;
          this.policyDataList = this.showpolicyList.slice(0, 10);
          this.searchInfo.total = r.data.total;
          loading.close();
          this.pagesize = 10;
          this.pagenum = 1;
        })
        .catch((e) => {});
    },
    // 对象数组按某一元素排序
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      };
    },
    // 获取自己的政策
    getmytabelList() {
      let url = "/dev-api/avoid/apply/selectAvoidApplyOne";
      let params = {
        pageSize: this.searchInfo.pageSize,
        pageNum: this.searchInfo.pageSize,
        tyshxydm: this.userInfo.tyshxydm,
        policyLevel: this.searchInfo.policyLevel,
      };
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "loadingin",
      });
      this.$httpApi
        .post(url, params)
        .then((r) => {
          this.policyDataList = r.data.list;
          this.searchInfo.total = r.data.total;
          loading.close()
        })
        .catch((e) => {});
    },
    queryLabelDept() {
      let url = "/dev-api/enterprise-label/queryLabelDept";
      let params = {};
      this.$httpApi
        .post(url, params)
        .then((res) => {
          this.hydlList = res.data;
        })
        .catch((err) => {
          console.log("evaluate error:", err);
        });
    },
    getDeptList() {
      let url = "/system/dept/getMianshenDeptByAreaIds";
      let data;
      if (this.searchDataAreaId == "") {
        //如果选择不限
        data = {
          areaId: "411500000000",
        };
      } else {
        //如果有值，替换值。
        data = {
          areaId: this.searchDataAreaId,
        };
      }
      this.$httpApi
        .get(url, data)
        .then((res) => {
          if (res.data && !!res.data.length) {
            this.hydlList = res.data || [];
          } else {
            this.hydlList = res.data || [];
          }
        })
        .catch((err) => {
          console.log("getDeptList error:", res);
        });
    },
    handleSelect(event) {
      if (event.label == "全部") {
        this.searchInfo.policyLevel = "";
      } else {
        this.searchInfo.policyLevel = event.name;
      }
      if (this.radio1 == "1") {
        this.gettabelList();
      } else {
        this.getmytabelList();
      }
    },
    changeTab(param) {
      this.tabActive = param;
      this.requesturlType = -1;  //  初始化
      if (param == "policy") {
        this.requesturl = "/dev-api/avoid/apply/selectAvoidApplyList";
        this.buttonText = '查看详情';
      } else if(param == "policy1"){
        this.requesturl = "/dev-api/avoid/apply/selectAvoidApplyList";
        this.requesturlType = 2;
        this.buttonText = '兑现详情';
      } else if(param == "policy2"){
        this.requesturl = "/dev-api/avoid/apply/selectAvoidApplyList";
        this.requesturlType = 0;
        this.buttonText = '查看详情';
      } else {
        this.requesturl = "/dev-api/avoid/apply/selectAvoidApplyItemList";
        this.buttonText = '查看详情';
      }
      this.cleanparams();
      this.gettabelList();
    },
    chooseChange(val) {
      let currentChoose = val;
      this.tabIndex = "''";
      if (val == "2") {
        this.tabActive = "project";
      } else {
        this.tabActive = "policy";
      }
      this.requesturl = "/dev-api/avoid/apply/selectAvoidApplyList";
      this.policyDataList = [];
      switch (currentChoose) {
        case "1":
          this.gettabelList();
          break;
        case "2":
          if (this.userInfo) {
            this.getmytabelList();
          } else {
            this.$router.push({ path: "/login2" });
          }
          break;
        default:
          break;
      }
    },
    // 行政区划查询
    getAreaList() {
      let url = "/cfginfo/region/cascaderTreeList";
      this.$httpApi
        .get(url, { parentid: "411500000000" })
        .then((res) => {
          // console.log('getDeptList:', res)
          if (res.data && !!res.data.length) {
            this.areaList = res.data || [];
          }
          console.log("行政区划查询" + res);
        })
        .catch((err) => {
          console.log("getAreaList error:", res);
        });
    },
    getquestionList() {
      let params = {
        pageSize: 10,
        pageNum: 1,
      };
      let that = this;
      let url = "/dev-api/avoid/apply/selectQuestionList";
      this.$httpApi.post(url, params).then((r) => {
        if (r.code == 200) {
          that.questionList = r.data.list;
        }
      });
    },
    /**
     * @description: 切换页码
     * @param {Number} page 页码
     */
    handleCurrentChange(page) {
      // this.policyDataList = []
      // this.searchInfo.pageNum = page;
      // let url = "/dev-api/avoid/apply/selectAvoidApplyList";
      // this.$httpApi
      //   .post(url, this.searchInfo)
      //   .then((r) => {
      //     this.policyDataList = r.data.list;
      //     this.searchInfo.total = r.data.total;
      //   })
      //   .catch((e) => {});
      this.pagenum = page;
      this.policyDataList = [];
      this.policyDataList = this.showpolicyList.slice(
        this.pagesize * (page - 1),
        this.pagesize * page
      );
    },
    handleSizeChange(page) {
      this.pagesize = page;
      this.pagenum = 1;
      this.policyDataList = [];
      this.policyDataList = this.showpolicyList.slice(
        page * (this.pagenum - 1),
        this.pagenum * page
      );
    },
    cleanparams() {
      this.searchInfo.keyWord = "";
      this.searchInfo.zcfs = "";
      this.searchInfo.policyLevel = "";
      this.searchInfo.startTime = "";
      this.searchInfo.deptId = "";
      this.searchInfo.pageSize = 10000;
      this.searchInfo.pageNum = 1;
      this.searchInfo.total = 0;
      this.tabIndex = "''";
    },
    open(text) {
      this.$alert(text, '兑现详情');
    },
    topage(item) {
      let row = item.row;
      row.content ="";
      window.sessionStorage.setItem("requesturlType", '');  //  置为空
      if (this.tabActive == "policy" || this.tabActive == "policy1" || this.tabActive == "policy2") {
        let data = JSON.stringify(row);
        sessionStorage.setItem("policyDetailData", data);
        window.sessionStorage.setItem("flag", false);
        window.sessionStorage.setItem("status", false);
        let { href } = this.$router.resolve({
          name: "showPolicyDetail",
        });
        window.sessionStorage.setItem("requesturlType", this.requesturlType);  //  用于回退回来跳转到指定的分类下面
        window.open(href, "_blank");
      } else {
        this.$store.commit("updateCurrentGuideId", row.itemId);
        let { href } = this.$router.resolve({
          name: "guideSuqiu",
          query: {
            name: row.itemName,
            itemType: "2",
            // isAdded: item.row.isAdded,
            ismsjx: true,
          },
        });
        window.open(href, "_blank");
      }
    },
    topage2(item) {
      let row = item.row;
      row.content ="";
      window.sessionStorage.setItem("requesturlType", '');  //  置为空
      if (this.tabActive == "policy") {
        let data = JSON.stringify(row);
        sessionStorage.setItem("policyDetailData", data);
        window.sessionStorage.setItem("flag", false);
        window.sessionStorage.setItem("status", false);
        let { href } = this.$router.resolve({
          name: "showPolicyDetail",
        });
        window.sessionStorage.setItem("requesturlType", this.requesturlType);  //  用于回退回来跳转到指定的分类下面
        window.open(href, "_blank");
      }else if(this.tabActive == "policy1"){  //  兑现详情
        this.open(row.detail || '暂无内容');
      }else if(this.tabActive == "policy2"){  //  确认兑现
        // this.dialogVisible = true;
        // let item = row;
        // this.formData['userId'] = this.userInfo.userId;
        // this.formData['enterpriseFr'] = this.userInfo.enterpriseInfo.name;
        // this.formData['phone'] = this.userInfo.enterpriseInfo.phone;
        // this.formData['enterpriseName'] = this.userInfo.enterpriseInfo.enterprise;
        // this.formData['endTime'] = item.startTime + '至' + this.cpu_limitTime(item.endTime);
        // this.formData['policyName'] = item.policyName;
        // this.formData['policyId'] = item.policyId;
        let data = JSON.stringify(row);
        sessionStorage.setItem("policyDetailData", data);
        window.sessionStorage.setItem("flag", false);
        window.sessionStorage.setItem("status", false);
        let { href } = this.$router.resolve({
          name: "showPolicyDetail",
        });
        window.sessionStorage.setItem("requesturlType", this.requesturlType);  //  用于回退回来跳转到指定的分类下面
        window.open(href, "_blank");
      } else {
        this.$store.commit("updateCurrentGuideId", row.itemId);
        let { href } = this.$router.resolve({
          name: "guideSuqiu",
          query: {
            name: row.itemName,
            itemType: "2",
            // isAdded: item.row.isAdded,
            ismsjx: true,
          },
        });
        window.open(href, "_blank");
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.haedTab {
  margin-top: 3.125rem;
}
.searchPart {
  width: 100%;
  background-color: #f9f9f9;
  margin-top: 1.25rem;
  .search_inner {
    padding: 2.4375rem 1.625rem 1.625rem 2.125rem;
    position: relative;
    .searchAbsolute {
      position: absolute;
      right: 1.625rem;
      bottom: 0rem;
    }
  }
}
.searchBtn2 {
  background-color: #1472FF;
  border-radius: unset;
  color: #fff;
  font-size: 1rem;
}
.searchChoosePart {
  margin: 0.9375rem auto;
  .searchLeft {
    height: 2.1875rem;
    line-height: 2.1875rem;
    font-size: 1rem;
    color: #999;
    margin-right: 10px;
  }
}
.re-top {
  padding-top: 1.5rem;
  height: 8.125rem;
}
.re-name {
  color: rgb(20, 114, 255);
  font-size: 1.375rem;
  font-weight: 700;
}
.re-info {
  font-size: 0.875rem;
  margin-top: 1vh;
  text-align: right;
  margin-right: 2vw;
}
.re-list {
  padding: 0vh 1vw 2vh 1vw;
}
.re-list-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 1.125rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
}
.re-list-info {
  font-size: 0.875rem;
  color: rgba(153, 153, 153, 1);
}
.rt-money {
  font-weight: 700;
  font-size: 1.5rem;
  color: rgb(20, 114, 255);
}
.rt-btn {
  height: 40px;
  line-height: 40px;
  background: #1472FF;
  color: #fff !important;
  font-size: 16px;
  padding: 0 18px;
  border-radius: 20px;
  text-align:
  center; border: 0;
  cursor: pointer;
}
.re-tag {
  display: inline-block;
  border-radius: 17px;
  border: 1px solid #1472FF;
  // width: 6.25rem;
  height: 34px;
  line-height: 32px;
  text-align: center;
  color: #1472FF;
  font-size: 1rem;
  margin: 0.3125rem;
  padding: 0 20px;
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
}
.re-start {
  float: right;
  margin-top: 0.2vh;
}
.pg-css {
  text-align: center;
  margin-top: 3vh;
}
.dt-top {
  font-family: Microsoft YaHei;
  font-weight: 700;
  font-size: 1.25rem;
  color: rgba(0, 0, 0, 1);
}
.dt-div-btn {
  text-align: center;
  margin-top: 2vh;
}
.dt-skip {
  border-color:  rgb(20, 114, 255);
  font-size: 18px;
  color:  rgb(20, 114, 255);
  width: 6vw;
  border-radius: unset;
}
.dt-confirm {
  border-color:  rgb(20, 114, 255);
  font-size: 1.125rem;
  background-color:  rgb(20, 114, 255);
  color: rgba(255, 255, 255, 1);
  border-radius: unset;
  width: 6vw;
}
.resultPart {
  width: 50%;
  margin: 0 auto;
  .successPart {
    width: 11.5875rem;
    height: 8.9138rem;
    margin: 4.125rem auto 2rem auto;
  }
  p {
    text-align: center;
    line-height: 1.875rem;
    color: #000;
    font-size: 1rem;
  }
}
::v-deep {
  .el-radio-button__inner {
    height: 3.75rem;
    line-height: 2;
    font-weight: 700;
    font-size: 20px;
    border: 1px solid #1472FF;
    color: #1472FF;
    @media screen and (min-width: 1366px) {
      width: 35.9375rem;
    }
    @media screen and (min-width: 1600px) {
      width: 40.875rem;
    }
    @media screen and (min-width: 1920px) {
      width: 44.9375rem;
    }
  }
  .el-radio-button__inner:hover {
    color: "unset";
  }
  .el-input-group__append button.el-button {
    width: 7.5rem;
    background-color: #1472FF;
    border-radius: unset;
    color: #fff;
    font-size: 1rem;
  }
  .el-input__inner {
    border-color: #1472FF;
    font-size: 1rem;
  }
  .el-input__inner :hover {
    border-color: #1472FF;
  }
  .searchRight .el-radio-button__inner {
    width: 100px;
    height: 35px;
    line-height: 1;
    font-weight: 500;
    font-size: 16px;
    border: unset;
    color: #000;
    background-color: unset;
    border-radius: 0;
    margin: auto 5px;
  }
  .searchRight .el-radio-button.is-active .el-radio-button__inner {
    border: 1px solid #1472FF;
    color: #1472FF;
    background-color: #ffe2e2;
  }
  .searchRight .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    box-shadow: unset;
  }
  .searchRight .el-range-editor.is-active,
  .el-range-editor.is-active:hover {
    border-color: #1472FF;
  }
  .el-tabs__item {
    font-size: 20px;
    font-weight: 700;
    color: #000;
  }
  .el-tabs__item.is-active {
    color: #1472FF;
  }
  .el-tabs__active-bar {
    border-bottom: 2px solid #1472FF;
    color: #1472FF;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1472FF;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #1472FF;
  }
  .el-form-item__label {
    color: #000;
    font-size: 18px;
  }
  .el-radio__label {
    color: #000;
    font-size: 16px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #000;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #1472FF;
    background: #1472FF;
  }
  .el-dialog__body{
    display: none;
  }
  .upload-demo{
    text-align: left;
  }
  .edit {
    color: #fff;
    background-color: rgb(20, 114, 255);
    border-color: rgb(20, 114, 255);
  }
  .el-dialog__title{
    font-weight: 600;
  }
}
::v-deep {
  .filter-item {
    font-size: 16px;
    padding: 10px 0;
  }
  .filterItem-label {
    color: #999;
  }
}

.tabCon {
  display: flex;
  align-items: center;
  height: 50px;
  margin-bottom: 38px;
  justify-content: space-between;
  .tabItem {
    width: 395px;
    background: #F1F3FC;
    font-size: 18px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #000;
    &:hover {
      // border-bottom: 3px solid #e0240a;
      // color: #e0240a;
      background: #1472FF;
      color: #fff;
    }
  }

  .clicked {
    background: #1472FF;
    color: #fff;
  }
}
::v-deep {
  .filterItem-content {
    overflow: hidden;
  }
}
.bgImg{
  position: absolute;
  height: 120px;
  margin-top: -50px;
  background-image: url("~@/assets/images/header/998.png");
  width: 100%;
  min-width: 1224px;
}
</style>
<style>
.el-message-box__wrapper p{
  text-indent: 2rem;
}
</style>
